module.exports = __webpack_public_path__ + "static/media/check_green (copy).c2ded291.svg";